import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import AddonService from "services/addon-service";

function AddonPaymentSuccess() {
    const navigate = useNavigate();
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [validSuccess, setValidSuccess] = useState(false);
    const [loading, setLoading] = useState(true);

    // Guard against React 18 Strict Mode double-invocation
    const effectRan = useRef(false);

    useEffect(() => {
        if (effectRan.current) return;
        effectRan.current = true;

        const checkBillingStatus = async () => {
            try {
                const response = await AddonService.getLatestAddonBilling();
                const billing = response.billing;

                if (billing && billing.status === 'Success' && billing.display_result === true) {
                    setValidSuccess(true);
                    setShowSnackbar(true);

                    // Invalidate immediately
                    await AddonService.updateAddonBilling(billing.session_id, { display_result: false });
                } else {
                    console.warn("⚠️ Addon billing record invalid or already shown. Redirecting...");
                    navigate("/profile");
                }
            } catch (err) {
                console.error("❌ Error checking addon billing:", err);
                navigate("/profile");
            } finally {
                setLoading(false);
            }
        };

        checkBillingStatus();
    }, [navigate]);

    if (loading) return null; // Or loading spinner

    if (!validSuccess) return null;

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="60vh"
            >
                <Card
                    sx={{
                        p: 4,
                        maxWidth: 460,
                        width: "90%",
                        borderRadius: "16px",
                        textAlign: "center",
                        backgroundColor: "rgba(255,255,255,0.95)", // Glass-ish
                        boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                    }}
                >
                    <MDTypography variant="h1" sx={{ mb: 1, fontSize: "4rem !important" }}>
                        🚀
                    </MDTypography>

                    <MDTypography variant="h4" fontWeight="bold" gutterBottom color="dark">
                        Add-on Successfully Added!
                    </MDTypography>

                    <MDTypography variant="body2" color="text" sx={{ mb: 3 }}>
                        Your new add-on limits have been activated and are ready to use.
                    </MDTypography>

                    <MDButton
                        variant="contained"
                        color="accent"
                        size="large"
                        onClick={() => navigate("/profile")}
                        sx={{ px: 4, py: 1.5, fontWeight: 600, width: "100%" }}
                    >
                        Back to Profile
                    </MDButton>
                </Card>
            </MDBox>

            <Snackbar
                open={showSnackbar}
                autoHideDuration={6000}
                onClose={() => setShowSnackbar(false)}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    onClose={() => setShowSnackbar(false)}
                    severity="success"
                    sx={{ width: "100%" }}
                >
                    Add-on purchase successful!
                </Alert>
            </Snackbar>
            <Footer />
        </DashboardLayout>
    );
}

export default AddonPaymentSuccess;
